<template>
  <i-loading v-if="loading" overlay />
  <i-page class="layout">
    <p-navbar />
    <i-page-content class="layout__content">
      <router-view  :key="$route.fullPath"/>
    </i-page-content>
  </i-page>
</template>

<script>
import PNavbar from "@/components/partials/p-navbar";

import { registerServiceWorker } from "@/registerServiceWorker";
import { mapState } from "vuex";

export default {
  components: {
    PNavbar,
  },
  mounted() {
    registerServiceWorker();
  },
  computed: {
    ...mapState({
      loading: (state) => state.loading,
    }),
  },
};
</script>

<style scoped>
.layout__content {
  display: flex;
  flex-direction: column;
}
</style>
